/**
 * withLicenseBar HOC
 */

import { toggleLicenseBarVisibility } from '../redux/actions/ui';

import * as React from 'react';
import { connect } from 'react-redux';

interface IComponentWithLicenseBarDispatchProps {
  toggleVisibility(visible: boolean): void;
}

export default function withLicenseBar<P extends object>(UnwrappedComponent: React.ComponentType<P>) {
  type HOCProps = P & IComponentWithLicenseBarDispatchProps;

  class WithLicenseBar extends React.Component<HOCProps> {
    componentDidMount() {
      this.props.toggleVisibility(true);
    }

    componentWillUnmount() {
      this.props.toggleVisibility(false);
    }

    render() {
      return <UnwrappedComponent {...this.props} />;
    }
  }

  return connect<{}, IComponentWithLicenseBarDispatchProps, P, IStoreState>(
    null,
    (dispatch) => ({
      toggleVisibility: (visible) => {
        dispatch(toggleLicenseBarVisibility(visible));
      },
    }),
  // @ts-ignore: I don't understand why type doesn't match here
  )(WithLicenseBar);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/withLicenseBar.tsx